import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getLabTests } from "../../apis/LabOrder";
import { Filter } from "../../interfaces/Filter";
import Filters from "../../components/Filters";
import { Pagination, PaginationProps,Button, Dropdown } from "antd";
import CommonPagination from "../../components/CommanPagination";

const TestList: React.FC = () => {
  const [tests, setTests] = useState<any[]>([]);
  const navigate = useNavigate();
  const [meta, setMeta] = useState<any>({});
  
 const allFilters: Array<Filter> = [
  { label: "Name", key: "name", value: "", component: "input" },
  { label: "Code", key: "code", value: "", component: "input" },
];
const [filters, setFilters] = useState<Array<Filter>>([]);

  const fetchTests = (params: any = { page: 1, per_page: 10 }) => {
    getLabTests(params)
      .then((res: any) => {
        const dataArray = Array.isArray(res.data.data) ? res.data.data : res.data;
        const sortedTests = dataArray.sort((a: any, b: any) => b.id - a.id);
        setTests(sortedTests);
        setMeta(res.data.meta || { total: sortedTests.length });
      })
      .catch((err) => console.error(err));
  };

  useEffect(() => {
    fetchTests({ page: 1, per_page: 10 });
  }, []);

  const handleFilters = (appliedFilters: Array<Filter>) => {
    const params: Record<string, any> = { page: 1, per_page: 10 };
    appliedFilters.forEach((f) => {
      if (f.value) params['search'] = f.value;
    });
    fetchTests(params);
  };

  const handleViewTest = (testId: number) => {
    navigate(`/lab-tests/view/${testId}`);
  };

  // const onPaginationChange: PaginationProps["onChange"] = (page, pageSize) => {
  //   fetchTests({ page, per_page: pageSize });
  // };
 const onPaginationChange = (page: number, pageSize?: number) => {
  fetchTests({ page, per_page: pageSize || 10 }); 
};

  return (
    <div className="px-4 sm:px-6 lg:px-8">
      {/* Header */}
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center mb-4">
        <div>
          <h1 className="text-base font-semibold leading-6 text-gray-900">
            Tests List
          </h1>
          <p className="mt-1 text-sm text-gray-600">
            Manage laboratory tests and their parameters
          </p>
        </div>
        <div className="flex gap-2">
          <Filters
            clearFilterList={false}
            filters={allFilters}
            fetchList={(appliedFilters) => handleFilters(appliedFilters)}
          />

          <button
            onClick={() => navigate("/lab-tests/add")}
            className="mt-3 sm:mt-0 px-4 py-2 text-sm font-semibold text-white bg-primary rounded-md hover:bg-hover"
          >
            Add Test
          </button>
        </div>
      </div>

      {/* Table */}
      <div className="overflow-x-auto">
        <div className="inline-block min-w-full align-middle">
          <div className="overflow-hidden border border-gray-200 rounded-lg">
            <table className="min-w-full divide-y divide-gray-300">
              <thead className="bg-gray-50">
                <tr>
                  {/* <th className="px-4 py-3 text-left text-sm font-semibold text-gray-900">
                    ID
                  </th> */}
                  <th className="px-4 py-3 text-left text-sm font-semibold text-gray-900">
                    Test Name
                  </th>
                  <th className="px-4 py-3 text-left text-sm font-semibold text-gray-900">
                    Code
                  </th>
                  <th className="px-4 py-3 text-left text-sm font-semibold text-gray-900">
                    Default Charge
                  </th>
                  <th className="px-4 py-3 text-left text-sm font-semibold text-gray-900">
                    Action
                  </th>
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-gray-200">
                {tests.length > 0 ? (
                  tests.map((test) => (
                    <tr key={test.id} className="hover:bg-gray-50">
                      {/* <td className="px-4 py-4 text-sm font-medium text-gray-900">
                        {test.id}
                      </td> */}
                      <td className="py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-6">
                        {test.name}
                      </td>
                      <td className="px-4 py-4 text-sm text-gray-900">
                        {test.code || "-"}
                      </td>
                      <td className="px-4 py-4 text-sm text-gray-900">
                        {test.defaultCharge ? `₹${test.defaultCharge}` : "-"}
                      </td>
                      <td className="px-4 py-4 text-sm text-gray-900">
                        <Dropdown
                          menu={{
                            items: [
                              {
                                key: "view",
                                label: (
                                  <span
                                    onClick={() => handleViewTest(test.id)}
                                    className="cursor-pointer"
                                  >
                                    View
                                  </span>
                                ),
                              },
                              {
                                key: "edit",
                                label: (
                                  <span
                                    onClick={() => navigate(`/lab-tests/edit/${test.id}`)}
                                    className="cursor-pointer"
                                  >
                                    Edit
                                  </span>
                                ),
                              },
                            ],
                          }}
                          placement="bottomLeft"
                        >
                          <Button>Actions</Button>
                        </Dropdown>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td
                      colSpan={5}
                      className="px-4 py-4 text-center text-sm text-gray-500"
                    >
                      No tests found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
          {/* Pagination */}
            {/* <div className="flex justify-end pt-5">
                          <Pagination
                            defaultCurrent={1}
                            defaultPageSize={10}
                            total={meta?.total}
                            onChange={onPaginationChange}
                          />
            </div> */}
            <CommonPagination meta={meta} onChange={onPaginationChange} />
        </div>
      </div>
    </div>
  );
};

export default TestList;
